export class TransactionModal {
   id: string;
   paymentId: string;
   invoiceId: string;
   productId: string;
   promoId: string;
   saGenerateLicenseId: string;
   quantity: number;
   amountRecieved: number;
   discountAmount: number;
   totalAmount: number;
   status: boolean;
   addedServices: string;
}
